module.exports = __webpack_public_path__ + "img/wiktor-karkocha-WA2uSCbTXkI-unsplash 1.15e1b188.png";